import { panel } from "../../styles";

export default function NotFound () {
  return (
    <div class={panel}>
      Page not found
    </div>
  )
}
